import { type BundleNode, isDecisionNode, isEnumType, isManagedNode, isRulesNode, isTaskNode } from '../../store/types';

type ConditionOption = { key: string; values: string[] };

const conditionOptions = (nodes: BundleNode[]): ConditionOption[] =>
  nodes.flatMap<ConditionOption>(node => {
    const task = isManagedNode(node) ? node.task : isTaskNode(node) ? node : null;
    if (task) {
      return task.fields
        .filter(
          field => isEnumType(field.type) && field.name.trim() && (field.enumValues ?? []).some(value => value.trim()),
        )
        .map(field => ({
          key: `outputs.${field.name.trim()}`,
          values: [...new Set((field.enumValues ?? []).map(value => value.trim()).filter(Boolean))],
        }));
    }
    if (isRulesNode(node) && node.key.trim()) {
      const values = [node.defaultValue, ...node.groups.map(group => group.value)]
        .map(value => value.trim())
        .filter(Boolean);
      return values.length ? [{ key: `outputs.${node.key.trim()}`, values: [...new Set(values)] }] : [];
    }
    if (isDecisionNode(node)) {
      return node.questions.flatMap<ConditionOption>(question => {
        const key = question.key.trim();
        if (!key) return [];
        if (question.kind === 'yes_no') return [{ key: `outputs.${key}`, values: ['true', 'false'] }];
        if (question.kind === 'score') return [];
        const values = question.options.map(option => option.value.trim()).filter(Boolean);
        return values.length ? [{ key: `outputs.${key}`, values: [...new Set(values)] }] : [];
      });
    }
    return [];
  });

export type { ConditionOption };
export { conditionOptions };
